import styled from "styled-components";

const alphabet = "#ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

const Wrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  margin-bottom: 1.5rem;
  justify-content: center;
`;

const Btn = styled.button`
  width: 2rem;
  height: 2rem;
  border-radius: 0.25rem;
  font-size: 0.75rem;
  font-weight: 600;
  transition: background 0.15s, color 0.15s;
  border: 1px solid hsl(${({ theme }) => theme.colors.border});
  background: ${({ $on, theme }) =>
    $on ? `hsl(${theme.colors.primary})` : `hsl(${theme.colors.card})`};
  color: ${({ $on, theme }) =>
    $on ? `hsl(${theme.colors.primaryForeground})` : `hsl(${theme.colors.foreground})`};
  &:hover {
    background: ${({ $on, theme }) =>
      $on ? `hsl(${theme.colors.primary})` : `hsl(${theme.colors.muted})`};
  }
`;

export default function StoresAlphabetNav({ filterLetter, onFilterLetter }) {
  return (
    <Wrap>
      <Btn type="button" $on={!filterLetter} onClick={() => onFilterLetter(null)}>
        All
      </Btn>
      {alphabet.map((letter) => (
        <Btn
          key={letter}
          type="button"
          $on={filterLetter === letter}
          onClick={() =>
            onFilterLetter(filterLetter === letter ? null : letter)
          }
        >
          {letter}
        </Btn>
      ))}
    </Wrap>
  );
}
